<template>
  <div>
    <layout :title="$t('test.title')">
      <div slot="layout-content">
        <template v-if="!isLoading">
          <template v-for="evaluation in evaluationInProgress">
            <b-list-group
              :key="evaluation.id"
              class="pb-3"
              flush
            >
              <b-list-group-item class="list-unstyled d-flex justify-content-between align-items-center pb-0 list-test text-center">
                <div
                  :style="`background-image: url(${$helper.getImage(evaluation.test.image.file_name)})`"
                  class="list-image"
                />
                <div>
                  <span class="text-primary">
                    {{ $t('test.name') }}
                  </span>
                  <br>
                  {{ evaluation.test.label }}
                </div>
                <div>
                  <span class="text-primary">
                    {{ $t('test.module') }}
                  </span>
                  <br>
                  {{ evaluation.test.module_label || getModuleLabelFromIdTest(evaluation.test.id) }}
                </div>
                <div v-if="$helper.canShowLanguage">
                  <span class="text-primary">
                    {{ $t('test.language') }}
                  </span>
                  <br>
                  {{ evaluation.test.language | formatCountryCode }}
                </div>
                <div>
                  <bt-to-player
                    v-if="$helper.hasPlayerWeb"
                    :career-id="evaluation.id"
                    :qs="{player: get().enums.player.eval, in_progress: true}"
                  >
                    {{ $t('actions.resume_test') }}
                  </bt-to-player>
                </div>
              </b-list-group-item>
            </b-list-group>
          </template>
          <test-list
            :tests="evaluations"
            :has-test-already-in-progress="!_.isEmpty(evaluationInProgress)"
            :modules-label="modulesLabel"
            :player="get().enums.player.eval"
            :accessTest=true
            @openModal="$root.$emit('bv::show::modal', 'evaluationInProgress')"
          />
        </template>
        <loader-text
          v-else
          title="dashboard.loading"
        />
      </div>
    </layout>
    <b-modal
      id="evaluationInProgress"
      ok-only
    >
      {{ $t('exam.test_already_in_progress') }}
    </b-modal>
  </div>
</template>

<script>
  import LoadOnNavigate from '@/mixins/load-on-navigate';

  import BtToPlayer from '@/components/bt-to-player';
  import LoaderText from '@/components/loader-text';
  import TestList from '@/components/test-list';

  import Layout from '@/views/Layout';

  export default {
    name: 'EvaluationView',
    components: {
      BtToPlayer,
      Layout,
      LoaderText,
      TestList,
    },
    mixins: [
      LoadOnNavigate,
    ],
    props: {
      setHistory: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        evaluations: [],
        evaluationInProgress: [],
        modulesLabel: {},
        isLoading: true,
      };
    },
    methods: {
      async load() {
        if (this.setHistory) {
          window.history.pushState(null, document.title, window.location.href);
        }

        this.isLoading = true;
        const data = await this.$ajax.get('evaluations/');
        if (!this._.isArray(data.modules_label)) {
          this.modulesLabel = data.modules_label;
        }

        this.evaluations = this._.sortBy(data.pending_eval, 'test.syllabus_position');
        this.evaluationInProgress = data.ongoing_eval;

        this.isLoading = false;
      },
      getModuleLabelFromIdTest(idtest) {
        return this.modulesLabel[idtest].label || ' - ';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .layout-content {
    .list-image {
      width: 25%;
      height: 80px;
      background: {
        position: center;
        repeat: no-repeat;
        size: contain;
      }
    }
  }

  .list-test > div {
    flex: 1;
  }
</style>
